import { render, staticRenderFns } from "./franchisee-form.vue?vue&type=template&id=3137a9a8&scoped=true"
import script from "./franchisee-form.vue?vue&type=script&lang=js"
export * from "./franchisee-form.vue?vue&type=script&lang=js"
import style0 from "./franchisee-form.vue?vue&type=style&index=0&id=3137a9a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137a9a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3137a9a8')) {
      api.createRecord('3137a9a8', component.options)
    } else {
      api.reload('3137a9a8', component.options)
    }
    module.hot.accept("./franchisee-form.vue?vue&type=template&id=3137a9a8&scoped=true", function () {
      api.rerender('3137a9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/operation-manage/franchisee-form.vue"
export default component.exports